import request from '@/utils/request'

let TravelersApi = {

  /*出行人列表*/
  list(data) {
    return request._post('/shop/plus.travelers.Index/index', data);
},
/*添加出行人*/
add(data) {
    return request._post('/shop/plus.travelers.Index/add', data);
},
/*修改出行人*/
edit(data) {
    return request._post('/shop/plus.travelers.Index/edit', data);
},
/*删除出行人*/
del(data) {
    return request._post('/shop/plus.travelers.Index/del', data);
},
/*出行人详情*/
detail(data) {
  return request._post('/shop/plus.travelers.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.travelers.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.travelers.Setting/getSetting', data, errorback);
    },
}
export default TravelersApi;



// WEBPACK FOOTER //
// ./src/api/travelers.js